// no React import needed (no JSX in this module)
import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { replaceStrValues } from 'platform/shared/health-apps';
import { isRelationshipToVeteran } from '../../../../utils/helpers';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['financial-info-home-ownership-title']),
    homeOwnership: {
      ...yesNoUI(),
      'ui:options': {
        updateSchema: (formData, _schema, uiSchema, _index) => {
          const newUISchema = { ...uiSchema };
          let title =
            content['financial-info-home-ownership-question-title-default'];
          let hintText = 'you';
          if (isRelationshipToVeteran(formData) === 'custodian') {
            hintText = 'they';
            title =
              content['financial-info-home-ownership-question-title-custodian'];
          }
          if (newUISchema?.['ui:options']) {
            newUISchema['ui:options'].hint = replaceStrValues(
              content['financial-info-home-ownership-question-hint'],
              [hintText],
            );
          }
          return {
            title,
            uiSchema: newUISchema,
          };
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['homeOwnership'],
    properties: {
      homeOwnership: yesNoSchema,
    },
  },
};
